import { Component, OnInit } from '@angular/core';
import { lang_about } from 'app/idiomas/i18n/about/about.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { MatDialog } from '@angular/material/dialog';
import {KnowledgeBaseArticleComponent} from './article/article.component';


@Component({
  selector: 'app-acercade',
  templateUrl: './acercade.component.html',
  styleUrls: ['./acercade.component.scss']
})
export class AcercadeComponent implements OnInit {

  constructor(
  private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  private _matDialog: MatDialog
  ) {
    lang_about.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    }); }

  ngOnInit() {
  }
  readArticle()
  {
      this._matDialog.open(KnowledgeBaseArticleComponent, {
          // panelClass: 'knowledgebase-article-dialog',
          // data      : {article: article}
      });
  }

} 
